module.exports = __webpack_public_path__ + "img/checkmark-white.37435304.svg";